import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Badge, Card, Modal } from "react-bootstrap";
import { FaUsers, FaFileInvoiceDollar } from "react-icons/fa";

function BasicExample() {
  const [tipoCliData, setTipoCliData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");
        const localita = res.data.TP.localita || [];
        setAllData(localita);

        // AGGREGAZIONE: Somma Valore e Numero Doc per tipo_cliente
        const aggregation = localita.reduce((acc, item) => {
          const tipo = (item.tipo_cliente || "N/D").trim().toUpperCase();
          const valore = parseFloat(item.Valore || 0);
          const numDoc = parseInt(item.numero_doc || 0);

          if (!acc[tipo]) {
            acc[tipo] = {
              tipo_cliente: tipo,
              totaleValore: 0,
              totaleDoc: 0,
            };
          }

          acc[tipo].totaleValore += valore;
          acc[tipo].totaleDoc += numDoc;

          return acc;
        }, {});

        const transformedData = Object.values(aggregation);

        setTipoCliData(
          transformedData.sort((a, b) => b.totaleValore - a.totaleValore),
        );
      } catch (err) {
        console.error("Errore caricamento localita:", err);
      }
    };

    fetchData();
  }, []);

  const handleRowClick = (categoria) => {
    setSelectedCategory(categoria);
    setShowModal(true);
  };

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
    }).format(amount || 0);

  // Filtra le righe raw per categoria
  const modalDetailsRaw = allData.filter(
    (item) =>
      (item.tipo_cliente || "N/D").trim().toUpperCase() === selectedCategory,
  );

  // AGGREGAZIONE per cliente
  const modalDetailsAggregated = Object.values(
    modalDetailsRaw.reduce((acc, item) => {
      const nome = item.clienti || "N/D";

      if (!acc[nome]) {
        acc[nome] = {
          clienti: nome,
          paese: item.paese || "—",
          Valore: 0,
          numero_doc: 0,
        };
      }

      acc[nome].Valore += parseFloat(item.Valore || 0);
      acc[nome].numero_doc += parseInt(item.numero_doc || 0);

      return acc;
    }, {}),
  ).sort((a, b) => b.Valore - a.Valore);

  const totaleValoreModal = modalDetailsAggregated.reduce(
    (sum, item) => sum + item.Valore,
    0,
  );

  const totaleDocModal = modalDetailsAggregated.reduce(
    (sum, item) => sum + item.numero_doc,
    0,
  );

  const totaleClientiModal = modalDetailsAggregated.length;

  return (
    <>
      {/* =====================================================
          CARD / TABELLA TIPO CLIENTE
          ===================================================== */}

      <Card
        className="card ombra card-home border-0 tp-data-card tp-types-card tp-types-liquid"
        style={{
          borderRadius: "18px",
          padding: "1rem",
        }}
      >
        <div
          className="no-scrollbar tp-table-scroll tp-types-scroll"
          style={{
            overflowY: "auto",
          }}
        >
          <Table
            hover
            responsive
            className="mb-0 custom-table tp-types-table"
            style={{
              fontSize: "0.75rem",
              width: "100%",
              margin: 0,
              borderCollapse: "separate",
            }}
          >
            <thead
              className="sticky-top tp-table-head"
              style={{
                zIndex: 10,
              }}
            >
              <tr className="small">
                <th
                  style={{
                    width: "40%",
                  }}
                  className="ps-3 py-3 border-0"
                >
                  TIPO CLIENTE
                </th>

                <th
                  style={{
                    width: "35%",
                  }}
                  className="py-3 border-0 text-end"
                >
                  VALORE TOTALE
                </th>

                <th
                  style={{
                    width: "25%",
                  }}
                  className="py-3 border-0 text-end pe-3"
                >
                  DOC
                </th>
              </tr>
            </thead>

            <tbody>
              {tipoCliData.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => handleRowClick(item.tipo_cliente)}
                  style={{
                    cursor: "pointer",
                  }}
                  className="align-middle"
                >
                  <td className="fw-bold ps-3 tp-types-name">
                    {item.tipo_cliente}
                  </td>

                  <td className="text-end fw-bold tp-types-value">
                    {formatToEuro(item.totaleValore)}
                  </td>

                  <td className="text-end pe-3">
                    <Badge pill className="tp-types-doc-badge">
                      {item.totaleDoc}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* =====================================================
          MODAL DETTAGLIO CLIENTI PER CATEGORIA
          ===================================================== */}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        dialogClassName="tp-types-modal-dialog"
        contentClassName="tp-types-modal-content"
        backdropClassName="tp-types-modal-backdrop"
      >
        <Modal.Header
          closeButton
          className="border-0 tp-types-modal-header"
        >
          <Modal.Title className="tp-types-modal-title">
            <span className="tp-types-modal-kicker">TIPO CLIENTE</span>

            <strong>
              {selectedCategory || "N/D"}
            </strong>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="tp-types-modal-body">
          {/* KPI */}
          <div className="tp-types-kpi-grid">
            <div className="tp-types-kpi">
              <span>CLIENTI</span>

              <strong>
                <FaUsers />
                {totaleClientiModal}
              </strong>
            </div>

            <div className="tp-types-kpi">
              <span>DOCUMENTI</span>

              <strong>
                <FaFileInvoiceDollar />
                {totaleDocModal}
              </strong>
            </div>

            <div className="tp-types-kpi tp-types-kpi-red">
              <span>VALORE TOTALE</span>

              <strong>
                {formatToEuro(totaleValoreModal)}
              </strong>
            </div>
          </div>

          {/* DETTAGLIO */}
          <div className="tp-types-detail-box">
            <div className="tp-types-detail-header">
              <div>
                <span>DETTAGLIO CLIENTI</span>
                <strong>Clienti appartenenti alla categoria</strong>
              </div>

              <small>
                {totaleClientiModal} clienti
              </small>
            </div>

            <div className="tp-types-modal-scroll">
              <Table
                hover
                responsive
                className="mb-0 tp-types-modal-table"
              >
                <thead>
                  <tr>
                    <th className="ps-3">
                      RAGIONE SOCIALE
                    </th>

                    <th>
                      LOCALITÀ
                    </th>

                    <th className="text-end">
                      VALORE
                    </th>

                    <th className="text-center pe-3">
                      DOC
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {modalDetailsAggregated.map((client, i) => (
                    <tr
                      key={i}
                      className="align-middle"
                    >
                      <td className="ps-3 fw-bold small text-uppercase tp-types-modal-company">
                        {client.clienti}
                      </td>

                      <td className="small tp-types-modal-place">
                        {client.paese}
                      </td>

                      <td className="text-end fw-bold tp-types-value">
                        {formatToEuro(client.Valore)}
                      </td>

                      <td className="text-center pe-3">
                        <Badge pill className="tp-types-doc-badge">
                          {client.numero_doc}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* =====================================================
          CSS INTEGRATO
          ===================================================== */}

      <style>{`
        /* =====================================================
           CARD LIQUID GLASS GRIGIA
           ===================================================== */

        .tp-types-liquid {
          color: #262c33 !important;

          background:
            linear-gradient(
              145deg,
              rgba(216, 221, 226, 0.86),
              rgba(197, 203, 209, 0.78)
            ) !important;

          border:
            1px solid rgba(38, 44, 52, 0.09) !important;

          border-radius:
            18px !important;

          box-shadow:
            0 15px 34px rgba(35, 41, 49, 0.12),
            inset 0 1px 0 rgba(255,255,255,0.52) !important;

          backdrop-filter:
            blur(14px)
            saturate(112%) !important;

          -webkit-backdrop-filter:
            blur(14px)
            saturate(112%) !important;

          overflow:
            hidden !important;
        }


        /* =====================================================
           SCROLL
           ===================================================== */

        .tp-types-scroll {
          scrollbar-width:
            none !important;

          -ms-overflow-style:
            none !important;
        }

        .tp-types-scroll::-webkit-scrollbar {
          display:
            none !important;

          width:
            0 !important;

          height:
            0 !important;
        }


        /* =====================================================
           TABELLA PRINCIPALE
           ===================================================== */

        .tp-types-table {
          color:
            #4d555f !important;

          background:
            transparent !important;
        }

        .tp-types-table
        > :not(caption)
        > *
        > * {
          box-shadow:
            none !important;
        }

        .tp-types-table thead th {
          color:
            #646c76 !important;

          background:
            rgba(190,196,202,0.94) !important;

          border:
            0 !important;

          border-bottom:
            1px solid rgba(38,44,52,0.10) !important;

          font-size:
            0.64rem !important;

          font-weight:
            850 !important;

          letter-spacing:
            0.05em !important;
        }

        .tp-types-table tbody td {
          color:
            #515963 !important;

          background:
            rgba(210,215,220,0.40) !important;

          border:
            0 !important;

          border-bottom:
            1px solid rgba(38,44,52,0.07) !important;
        }

        .tp-types-table tbody tr:hover td {
          background:
            rgba(184,31,37,0.06) !important;
        }

        .tp-types-name {
          color:
            #252b32 !important;
        }

        .tp-types-value {
          color:
            #b81f25 !important;
        }


        /* =====================================================
           BADGE DOC
           bordo rosso + interno rosso chiaro trasparente
           ===================================================== */

        .tp-types-doc-badge {
          display:
            inline-flex !important;

          align-items:
            center;

          justify-content:
            center;

          min-width:
            38px;

          padding:
            4px
            8px !important;

          color:
            #a81920 !important;

          background:
            linear-gradient(
              135deg,
              rgba(184,31,37,0.16),
              rgba(184,31,37,0.07)
            ) !important;

          border:
            1px solid rgba(184,31,37,0.58) !important;

          border-radius:
            999px !important;

          box-shadow:
            inset 0 1px 0 rgba(255,255,255,0.28),
            0 3px 8px rgba(184,31,37,0.08) !important;

          backdrop-filter:
            blur(6px);

          -webkit-backdrop-filter:
            blur(6px);

          font-size:
            0.62rem !important;

          font-weight:
            850 !important;

          letter-spacing:
            0.02em;
        }

        /* sovrascrive il .badge globale */
        .tp-dashboard-shell
        .tp-dashboard-grid
        .badge.tp-types-doc-badge {
          color:
            #a81920 !important;

          background:
            linear-gradient(
              135deg,
              rgba(184,31,37,0.16),
              rgba(184,31,37,0.07)
            ) !important;

          border:
            1px solid rgba(184,31,37,0.58) !important;
        }


        /* =====================================================
           BACKDROP MODALE
           ===================================================== */

        .tp-types-modal-backdrop.show {
          opacity:
            0.88 !important;

          background:
            #0b0e12 !important;

          backdrop-filter:
            none !important;

          -webkit-backdrop-filter:
            none !important;
        }


        /* =====================================================
           DIALOG
           ===================================================== */

        .tp-types-modal-dialog {
          width:
            min(
              900px,
              calc(100vw - 32px)
            ) !important;

          max-width:
            900px !important;

          margin:
            16px auto !important;
        }


        /* =====================================================
           CONTENUTO MODALE LIQUID GLASS GRIGIO
           ===================================================== */

        .tp-types-modal-content {
          position:
            relative;

          max-height:
            calc(100dvh - 32px);

          overflow:
            hidden;

          color:
            #282e35 !important;

          background:
            radial-gradient(
              circle at 0% 0%,
              rgba(184,31,37,0.12),
              transparent 32%
            ),
            radial-gradient(
              circle at 100% 8%,
              rgba(255,255,255,0.30),
              transparent 28%
            ),
            linear-gradient(
              145deg,
              rgba(210,215,220,0.96),
              rgba(187,193,200,0.94)
            ) !important;

          border:
            1px solid rgba(38,44,52,0.10) !important;

          border-radius:
            24px !important;

          box-shadow:
            0 32px 80px rgba(18,23,29,0.36),
            inset 0 1px 0 rgba(255,255,255,0.52) !important;

          backdrop-filter:
            blur(15px)
            saturate(112%);

          -webkit-backdrop-filter:
            blur(15px)
            saturate(112%);
        }

        .tp-types-modal-content::before {
          content:
            "";

          position:
            absolute;

          top:
            0;

          left:
            24px;

          width:
            40%;

          height:
            1px;

          background:
            linear-gradient(
              90deg,
              #b81f25,
              transparent
            );

          pointer-events:
            none;

          z-index:
            5;
        }


        /* =====================================================
           HEADER MODALE
           ===================================================== */

        .tp-types-modal-header {
          padding:
            19px
            21px
            13px !important;

          background:
            rgba(219,223,228,0.56) !important;

          border-bottom:
            1px solid rgba(38,44,52,0.08) !important;
        }

        .tp-types-modal-title {
          display:
            flex;

          flex-direction:
            column;

          gap:
            2px;

          min-width:
            0;
        }

        .tp-types-modal-kicker {
          color:
            #747b84 !important;

          font-size:
            0.55rem;

          font-weight:
            850;

          letter-spacing:
            0.10em;
        }

        .tp-types-modal-title strong {
          color:
            #b81f25 !important;

          font-size:
            1.12rem;

          font-weight:
            900;

          letter-spacing:
            -0.01em;
        }

        .tp-types-modal-content .btn-close {
          width:
            32px;

          height:
            32px;

          margin:
            0 !important;

          padding:
            0 !important;

          border-radius:
            50%;

          background-color:
            rgba(55,62,71,0.09);

          background-size:
            11px;

          opacity:
            0.68;

          filter:
            none !important;
        }

        .tp-types-modal-content .btn-close:hover {
          opacity:
            1;

          background-color:
            rgba(184,31,37,0.10);
        }


        /* =====================================================
           BODY
           ===================================================== */

        .tp-types-modal-body {
          padding:
            12px
            18px
            18px !important;

          overflow-y:
            auto;

          overflow-x:
            hidden;

          background:
            transparent !important;

          scrollbar-width:
            none !important;

          -ms-overflow-style:
            none !important;
        }

        .tp-types-modal-body::-webkit-scrollbar {
          display:
            none !important;

          width:
            0 !important;

          height:
            0 !important;
        }


        /* =====================================================
           KPI
           ===================================================== */

        .tp-types-kpi-grid {
          display:
            grid;

          grid-template-columns:
            repeat(3, minmax(0,1fr));

          gap:
            10px;

          margin-bottom:
            12px;
        }

        .tp-types-kpi {
          padding:
            12px
            13px;

          background:
            rgba(223,227,231,0.48);

          border:
            1px solid rgba(38,44,52,0.075);

          border-radius:
            14px;

          box-shadow:
            inset 0 1px 0 rgba(255,255,255,0.40);
        }

        .tp-types-kpi-red {
          background:
            linear-gradient(
              145deg,
              rgba(184,31,37,0.11),
              rgba(221,225,229,0.48)
            );

          border-color:
            rgba(184,31,37,0.13);
        }

        .tp-types-kpi span {
          display:
            block;

          margin-bottom:
            4px;

          color:
            #727a84;

          font-size:
            0.54rem;

          font-weight:
            850;

          letter-spacing:
            0.075em;
        }

        .tp-types-kpi strong {
          display:
            flex;

          align-items:
            center;

          gap:
            6px;

          color:
            #2b3138;

          font-size:
            0.96rem;

          font-weight:
            850;
        }

        .tp-types-kpi strong svg {
          color:
            #b81f25;

          font-size:
            0.80rem;
        }

        .tp-types-kpi-red strong {
          color:
            #b81f25;
        }


        /* =====================================================
           BOX DETTAGLIO
           ===================================================== */

        .tp-types-detail-box {
          overflow:
            hidden;

          background:
            rgba(201,206,211,0.42);

          border:
            1px solid rgba(38,44,52,0.075);

          border-radius:
            16px;
        }

        .tp-types-detail-header {
          display:
            flex;

          align-items:
            center;

          justify-content:
            space-between;

          gap:
            12px;

          padding:
            11px
            13px;

          border-bottom:
            1px solid rgba(38,44,52,0.07);
        }

        .tp-types-detail-header > div {
          display:
            flex;

          flex-direction:
            column;
        }

        .tp-types-detail-header div span {
          color:
            #727a84;

          font-size:
            0.52rem;

          font-weight:
            850;

          letter-spacing:
            0.08em;
        }

        .tp-types-detail-header div strong {
          margin-top:
            2px;

          color:
            #353c44;

          font-size:
            0.76rem;
        }

        .tp-types-detail-header > small {
          color:
            #6d7580;

          font-size:
            0.62rem;

          font-weight:
            700;
        }


        /* =====================================================
           TABELLA MODALE
           ===================================================== */

        .tp-types-modal-scroll {
          max-height:
            390px;

          overflow:
            auto;

          scrollbar-width:
            none !important;

          -ms-overflow-style:
            none !important;

          overscroll-behavior:
            contain;
        }

        .tp-types-modal-scroll::-webkit-scrollbar {
          display:
            none !important;

          width:
            0 !important;

          height:
            0 !important;
        }

        .tp-types-modal-table {
          width:
            100%;

          margin:
            0 !important;

          color:
            #535b65 !important;

          background:
            transparent !important;
        }

        .tp-types-modal-table
        > :not(caption)
        > *
        > * {
          box-shadow:
            none !important;
        }

        .tp-types-modal-table thead th {
          position:
            sticky;

          top:
            0;

          z-index:
            3;

          padding:
            9px
            11px !important;

          color:
            #666e78 !important;

          background:
            rgba(185,191,198,0.96) !important;

          border:
            0 !important;

          border-bottom:
            1px solid rgba(38,44,52,0.09) !important;

          font-size:
            0.57rem;

          font-weight:
            850;

          letter-spacing:
            0.065em;

          white-space:
            nowrap;
        }

        .tp-types-modal-table tbody td {
          padding:
            10px
            11px !important;

          color:
            #515963 !important;

          background:
            rgba(210,215,220,0.32) !important;

          border:
            0 !important;

          border-bottom:
            1px solid rgba(38,44,52,0.065) !important;
        }

        .tp-types-modal-table tbody tr:hover td {
          background:
            rgba(184,31,37,0.055) !important;
        }

        .tp-types-modal-company {
          color:
            #252b32 !important;
        }

        .tp-types-modal-place {
          color:
            #6d7580 !important;
        }


        /* =====================================================
           MOBILE
           ===================================================== */

        @media screen and (max-width: 767px) {
          .tp-types-liquid {
            padding:
              0.85rem !important;
          }

          .tp-types-table thead th {
            padding:
              9px
              6px !important;

            font-size:
              0.55rem !important;
          }

          .tp-types-table tbody td {
            padding:
              10px
              6px !important;

            font-size:
              0.67rem !important;
          }

          .tp-types-modal-dialog {
            width:
              calc(100vw - 14px) !important;

            max-width:
              none !important;

            margin:
              7px auto !important;
          }

          .tp-types-modal-content {
            max-height:
              calc(100dvh - 14px);

            border-radius:
              19px !important;
          }

          .tp-types-modal-header {
            padding:
              15px
              14px
              10px !important;
          }

          .tp-types-modal-body {
            padding:
              9px
              12px
              12px !important;
          }

          .tp-types-kpi-grid {
            grid-template-columns:
              repeat(3, minmax(0,1fr));

            gap:
              6px;
          }

          .tp-types-kpi {
            padding:
              9px
              7px;
          }

          .tp-types-kpi span {
            font-size:
              0.46rem;
          }

          .tp-types-kpi strong {
            gap:
              3px;

            font-size:
              0.72rem;
          }

          .tp-types-modal-scroll {
            max-height:
              48vh;
          }

          .tp-types-modal-table thead th,
          .tp-types-modal-table tbody td {
            padding:
              9px
              8px !important;
          }
        }
      `}</style>
    </>
  );
}

export default BasicExample;
